//TODO:  Add a validateCriteria method to call in descendant  (make sure minimum criteria is provided)

import { ChangeDetectorRef, Component, HostListener, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';
import { DataSourceStatus, Datasource } from '@Core/services/proprietary/datasource';
import { DatasourceService } from '@Core/services/proprietary/datasource.service';
import { cloneDeep } from 'src/ep-utils';
import { SearchActionType, SearchOptionsType, SearchResultType } from '../../../../../core/services/proprietary/search.types';

@Component({
    standalone: false,
    selector: 'search-dialog',
    templateUrl: './search-dialog.component.html'
})
export class SearchDialogComponent {
    protected objectDisplayName: string; //override in descendant or set it initialize() --  used in title ( Consumer, Entity, Claim, etc. )
    protected objectType: string; //override in descendant or set it initialize()  --  (Entity, Consumer, Contract, etc.)

    model = {
        title: '<TITLE NOT SET IN DESCENDANT>',
        currentOptions: <SearchOptionsType>{},
        criteria: <any>{},
        dirty: false,
        searchText: '',
        modelProperty: ''
    };

    dsCollection: Datasource;

    ds: DataService;
    dsService: DatasourceService;
    app: AppService;
    cdRef: ChangeDetectorRef;

    protected parentActiveModal: NgbActiveModal;

    dsCollectionStatusSub: Subscription;

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        //console.log(event);
        if (event.keyCode === 27) {
            this.cancel();
        }
    }

    constructor(private ParentInjector: Injector) {
        // don't put injection parameters in constructor on an object that is EXTENDED
        // note "Injector" must be put in constructor of descedent
        this.ds = this.ParentInjector.get(DataService);
        this.dsService = this.ParentInjector.get(DatasourceService);
        this.app = this.ParentInjector.get(AppService);
        this.cdRef = this.ParentInjector.get(ChangeDetectorRef);

        this.dsCollection = this.ds.addNewDatasource();

        //TODO: HACK!!  The popup search dialog is not refreshing the view (sometimes) after the data is recieved.   this forces change detection.
        this.dsCollectionStatusSub = this.dsCollection.status$.subscribe((status: DataSourceStatus) => {
            if (status) {
                //console.log('search datasource status ' + status.valueOf())
                if (status == DataSourceStatus.Ready || status == DataSourceStatus.Error) {
                    // this.cdRef.detectChanges();
                    this.cdRef.markForCheck();
                    if (this.dsCollection.objectType == 'CodeSet') {
                        this.model.title = 'Select ' + this.dsCollection.objectNode?.Set_Name;
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.dsCollectionStatusSub) {
            this.dsCollectionStatusSub.unsubscribe();
        }
    }

    initialize(): boolean {
        //this function should be declared in descendant
        //this.icon and this.model.title and this.objectName should be set.
        //this.parentActiveModal MUST BE SET to injected ngbActiveModal in constructor of descendent
        //can be used to "set" or "force" criteria
        //can be used to test to see if required criteria is provided
        //if require criteria is missing show an error message and return false.
        return true;
    }

    private open(options?: SearchOptionsType) {
        /* default options */
        this.model.currentOptions = {
            allowClear: false,
            autoSearch: false,
            allowMultiSelect: false,
            maxRows: 100,
            maxRowLimiter: true,
            modelProperty: ''
        };

        //if options passed on a method  call then merge/replace with default options
        if (options) {
            for (var prop in options) {
                if (!options.hasOwnProperty(prop)) {
                    //The current property is not a direct property
                    continue;
                }
                this.model.currentOptions[prop] = options[prop];
            }
        }

        // set the property to search on (ie. Entity_Name)
        if (this.model.currentOptions.modelProperty) {
            let modelProp = this.model.currentOptions.modelProperty;
            this.dsCollection.criteria[modelProp] = this.model.criteria[modelProp];
        }

        //get autoSearch parameter
        let retrieveNow = false;
        if (this.model.currentOptions.autoSearch && this.model.currentOptions.autoSearch == true) {
            retrieveNow = true;
        }
        this.model.dirty = !retrieveNow; //since we are not retrieving now, set the model dirty to highlight search button

        if (this.initialize()) {
            this.dsCollection.objectType = this.objectType;
            this.dsCollection.maxRowLimiter = this.model.currentOptions.maxRowLimiter;
            this.dsCollection.maxRows = this.model.currentOptions.maxRows;
            //console.log("maxRowLimiter:" + this.dsCollection.maxRowLimiter);
            if (this.dsCollection.objectType == 'CodeSet') {
                this.dsCollection.get(this.model.criteria, retrieveNow);
            } else {
                this.dsCollection.getCollection(this.model.criteria, retrieveNow);
            }
        }
    }

    search(criteria?: any, options?: SearchOptionsType) {
        if (criteria) {
            this.model.criteria = cloneDeep(criteria);
        } else {
            this.model.criteria = JSON.parse('{}');
        }
        this.open(options);
    }

    action(actionType: string) {
        switch (actionType.toLowerCase()) {
            case 'select':
                this.select('{}');
                break;
            case 'cancel':
                this.cancel();
                break;
            case 'close':
                this.close();
                break;
            case 'clear':
                this.clear();
                break;
        }
    }

    closeModal(returnValue: SearchResultType) {
        if (this.parentActiveModal) {
            this.parentActiveModal.close(returnValue);
            return;
        } else {
            throw 'Search Dialog descendant did not properly set parentActiveModal in "initialize()"';
        }
    }

    close() {
        this.closeModal({ action: SearchActionType.Close });
    }

    cancel() {
        this.closeModal({ action: SearchActionType.Cancel });
    }

    select(objectNode: any) {
        if (this.model.currentOptions.allowMultiSelect && objectNode == '{}') {
            let selectedData: any = [];
            for (var i in this.dsCollection.objectNodes) {
                if (this.dsCollection.objectNodes[i].Selected) {
                    selectedData.push(this.dsCollection.objectNodes[i]);
                }
            }
            for (var i in selectedData) {
                delete selectedData[i].Selected; //Remove the Selected property from results.
            }
            if (selectedData.length > 0) {
                this.closeModal({ action: SearchActionType.Select, count: selectedData.length, data: selectedData });
            }
        } else {
            this.closeModal({ action: SearchActionType.Select, count: 1, data: [objectNode] });
        }
    }

    clear() {
        this.closeModal({ action: SearchActionType.Clear, data: [] });
    }

    recordClicked(objectNode: any, evt: any) {
        if (this.model.currentOptions.allowMultiSelect === true) {
            if (evt && evt.ctrlKey) {
                if (!objectNode.Selected) {
                    objectNode.Selected = true;
                } else {
                    objectNode.Selected = false;
                }
            } else {
                this.dsCollection.objectNodes.forEach((option) => {
                    option.Selected = false;
                });
                objectNode.Selected = true;
                this.select(objectNode);
            }
        } else {
            this.select(objectNode);
        }
    }

    checkboxClicked(objectNode: any) {
        if (!objectNode.Selected) {
            objectNode.Selected = true;
        } else {
            objectNode.Selected = false;
        }
    }
}
